// Голосовой оркестратор на телефоне: стек-экран { kind: 'orchestrator' }.
//
// Своей логики здесь нет — тот же стор и та же панель, что у десктопного
// раздела (sections/orchestrator). Разговор живёт в сторе, поэтому уход с
// экрана «назад» его не рвёт: кнопка в шапке подсвечивается, пока он идёт.

import { Icon } from '../ui/Icon'
import { OrchestratorPanel } from '../sections/orchestrator/Panel'
import { isLive, statusText, useOrchestrator } from '../sections/orchestrator/store'

interface Props { onOpenChat(sessionId: string): void }

export default function OrchestratorScreen({ onOpenChat }: Props) {
  return <OrchestratorPanel compact onOpenSession={onOpenChat} />
}

/** Строка под заголовком и признак «разговор идёт». */
export function useOrchestratorSub(): [string, boolean] {
  const status = useOrchestrator((s) => s.status)
  const muted = useOrchestrator((s) => s.muted)
  const autoMuted = useOrchestrator((s) => s.autoMuted)
  return [`голосовой ассистент · ${statusText(status, '', muted, autoMuted)}`, isLive(status)]
}

/** Кнопка с микрофоном для шапки корневого экрана. */
export function OrchestratorButton({ onOpen }: { onOpen(): void }) {
  const live = useOrchestrator((s) => isLive(s.status))
  return (
    <button
      type="button"
      className={`ab-mbtn ab-mbtn--orch${live ? ' is-live' : ''}`}
      onClick={onOpen}
      aria-label={live ? 'оркестратор: идёт разговор' : 'голосовой оркестратор'}
      title={live ? 'оркестратор: идёт разговор' : 'голосовой оркестратор'}
    >
      <Icon name="mic" size={20} />
    </button>
  )
}
